'use client'

import { FormattedMessage } from 'react-intl'
import { Spacer, Text } from '@vinted/web-ui'

import { OUR_PLATFORM_URL } from '../constants/routes'

const OurPlatformDisclaimer = () => {
  return (
    <div>
      <Spacer />
      <Text
        as="h4"
        inline
        text={<FormattedMessage id="our_platform.disclaimer" />}
        type={Text.Type.Caption}
      />{' '}
      <Text
        as="h4"
        text={
          <a href={OUR_PLATFORM_URL} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id="our_platform.disclaimer_link" />
          </a>
        }
        theme="primary"
        type={Text.Type.Caption}
      />
    </div>
  )
}

export default OurPlatformDisclaimer
